import React, {useContext} from "react";
import {RecordsManagementContext} from "../StatesMangement/InitialiseContext";

export default () => {//show details of the contact persons
    let IV2_PageDetails = useContext(RecordsManagementContext).IV2_PageDetails
    return (
        <>
            <strong>{IV2_PageDetails.ClientInfo}</strong>
            <div className='border border-dark text-info px-sm-2'>
                    <span>{IV2_PageDetails.ContactPersons.map((record, key) => {
                        return (<span key={key}>{record}</span>)
                    })}</span>
            </div>
            <div className='border border-dark px-sm-2 mt-2 bg-secondary'>
                <b>{IV2_PageDetails.EstAddress.EstType}</b>
            </div>
        </>
    )
}